let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("faflf")).then(() => parcelRequire('2IhFj'));